import { Component, OnInit, AfterViewInit, EventEmitter, Input, Output, SimpleChanges, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { ContractRetroreflectorization } from 'src/models/contract';

interface IRangeValues {
  first: number;
  second: number;
  third: number;
}

@Component({
  selector: 'app-retrorreflection-slider',
  templateUrl: './retrorreflection-slider.component.html',
  styleUrls: ['./retrorreflection-slider.component.css'],
})
export class RetrorreflectionSliderComponent implements AfterViewInit {
  parentDiv: HTMLElement;

  @ViewChildren('handleElement') handleElements!: QueryList<ElementRef>;

  handles = [{ position: 20 }, { position: 40 }, { position: 60 }];

  dragPositions: { x: number; y: number }[] = [
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
  ];

  showNumber: boolean[] = [false, false, false];

  @Input() maxValue: number = 400;
  @Input() retroRangeValues;
  @Output() emitRangeValues = new EventEmitter<IRangeValues>();
  @Input() emitResetRetro = new EventEmitter<boolean>();

  @Input() isModalOpen: boolean = false;

  constructor() {}

  ngAfterViewInit(): void {
    this.listenToReset();
    this.listenToHandleChanges();
    this.setPositionByRangeValues();
  }

  // Escuta o emissor do reset
  listenToReset() {
    this.emitResetRetro.subscribe((reset: boolean) => {
      this.setPositionByRangeValues(reset);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isModalOpen']) {
      this.adjustHandlesZIndex(this.isModalOpen ? '0' : '1100');
    }
  }
  
  adjustHandlesZIndex(zIndex: string) {
    this.handleElements?.forEach(handle => {
      handle.nativeElement.style.zIndex = zIndex;
    });
  }

  // atribui eventListeners aos handles do slider
  listenToHandleChanges() {
    // Retornando parente
    this.parentDiv = document.getElementById('line');

    // handle 0 - Primeiro handle
    const firstHandle = document.getElementById('handle0');
    // handle 1 - segundo handle
    const secondHandle = document.getElementById('handle1');
    // handle 2 - terceiro handle
    const thirdHandle = document.getElementById('handle2');

    // Evento quando solta o mouse
    firstHandle.addEventListener('pointerdown', (evt: any) => {
      this.showNumber[0] = true;
      this.setIntervalToHandle();
    });

    // Evento quando solta o mouse
    secondHandle.addEventListener('pointerdown', (evt: any) => {
      this.showNumber[1] = true;
      this.setIntervalToHandle();
    });

    // Evento quando solta o mouse
    thirdHandle.addEventListener('pointerdown', (evt: any) => {
      this.showNumber[2] = true;
      this.setIntervalToHandle();
    });
  }

  setIntervalToHandle() {
    const handleInterval = setInterval(() => {
      this.setFillerPositions();
    }, 10);

    addEventListener('mouseup', (evt) => {
      this.showNumber = [false, false, false];
      clearInterval(handleInterval);
    });
  }

  // Seta as posições dos fillers
  setFillerPositions(defaultValues: boolean = false) {
    // handle 0 - Primeiro handle
    const firstHandle = document.getElementById('handle0');
    var firstfiller = document.getElementById('fill-0');
    // handle 1 - segundo handle
    const secondHandle = document.getElementById('handle1');
    var secondfiller = document.getElementById('fill-1');
    // handle 2 - terceiro handle
    const thirdHandle = document.getElementById('handle2');
    var thirdfiller = document.getElementById('fill-2');
    // filler 3 - quarto filler
    var fourthfiller = document.getElementById('fill-3');

    // Preenchendo primeiro espaço, entre o primeiro botao e o inicio do pai
    firstfiller.style.width = this.returnElementLeftPosition(firstHandle).toString() + 'px';

    // Preenchendo segundo espaço, entre o primeiro botao e o segundo botao
    secondfiller.style.width =
      (this.returnElementLeftPosition(secondHandle) - this.returnElementLeftPosition(firstHandle)).toString() + 'px';
    secondfiller.style.left = this.returnElementLeftPosition(firstHandle).toString() + 'px';

    // Preenchendo terceiro espaço, entre o segundo botao e o terceiro botao
    thirdfiller.style.width =
      (this.returnElementLeftPosition(thirdHandle) - this.returnElementLeftPosition(secondHandle)).toString() + 'px';
    thirdfiller.style.left = this.returnElementLeftPosition(secondHandle).toString() + 'px';

    // Preenchendo quarto espaço, entre o ultimo botao e o final do pai
    fourthfiller.style.width =
      (this.parentDiv.offsetWidth - this.returnElementLeftPosition(thirdHandle)).toString() + 'px';
    fourthfiller.style.left = this.returnElementLeftPosition(thirdHandle).toString() + 'px';

    if (!defaultValues) {
      this.retroRangeValues = {
        id: this.retroRangeValues.id || undefined,
        contractId: this.retroRangeValues.contractId || undefined,
        bad: { from: 0, to: this.calculatePositionOutput(firstHandle) },
        regular: { from: this.calculatePositionOutput(firstHandle), to: this.calculatePositionOutput(secondHandle) },
        good: { from: this.calculatePositionOutput(secondHandle), to: this.calculatePositionOutput(thirdHandle) },
        excellent: { from: this.calculatePositionOutput(thirdHandle), to: this.retroRangeValues.maximumValue },
        maximumValue: this.retroRangeValues.maximumValue,
      };

      // Emissor para componente pai
      this.emitRangeValues.emit({
        first: this.calculatePositionOutput(firstHandle),
        second: this.calculatePositionOutput(secondHandle),
        third: this.calculatePositionOutput(thirdHandle),
      });
    }
  }

  // Retorna a posição left relativa ao parente
  returnElementLeftPosition(handleDiv: Element): number {
    return handleDiv.getBoundingClientRect().left - this.parentDiv.getBoundingClientRect().left + 1;
  }

  calculatePositionOutput(handleElement: HTMLElement) {
    // (100 * left do handle ) / tamanho do pai
    const percentageOfWidth = (100 * this.returnElementLeftPosition(handleElement)) / this.parentDiv.offsetWidth;
    return Math.floor((percentageOfWidth / 100) * this.maxValue);
  }

  // Seta as posições de cada range com um input de IRangeValues
  setPositionByRangeValues(defaultValues?: boolean) {
    this.dragPositions = [];

    const maxValueFormated = defaultValues ? 400 : this.maxValue;

    this.dragPositions.push({
      x: Math.floor(
        (this.parentDiv.offsetWidth * (defaultValues ? 200 : this.retroRangeValues.bad.to)) / maxValueFormated,
      ),
      y: 0,
    });

    this.dragPositions.push({
      x: Math.floor(
        (this.parentDiv.offsetWidth * (defaultValues ? 250 : this.retroRangeValues.regular.to)) / maxValueFormated,
      ),
      y: 0,
    });

    this.dragPositions.push({
      x: Math.floor(
        (this.parentDiv.offsetWidth * (defaultValues ? 300 : this.retroRangeValues.good.to)) / maxValueFormated,
      ),
      y: 0,
    });

    setTimeout(() => {
      this.setFillerPositions(defaultValues);
    }, 50);
  }
}
